export const OFFERS_STORAGE_KEY = "shawarmaDoseOffers";
export const OFFERS_UPDATED_EVENT = "offers:update";
export const DEFAULT_OFFER_PERCENT = 35;

const defaultBestAr = [
  "وجبة شاورما دجاج عربي",
  "سندويش شاورما دجاج كبير",
  "دوز كلاسيك برغر",
  "سندويش شاورما دجاج خبز صمون مع جبنة",
  "ساندويتش دجاج سوبريم",
  "ساندويتش شيش طاووق دجاج",
].map((s) => (s || "").toString().trim());

const defaultBestEn = [
  "Dose Classic Burger",
  "Medium Chicken Sandwich - 80g",
  "Medium Chicken Sandwich 80g",
  "Large Chicken Sandwich 100g",
  "Large Chicken Sandwich - 100g",
  "Fries Sandwich 100g with Mozzarella Cheese",
  "Fries",
  "Medium Meat Sandwich 80g",
  "Medium Meat Sandwich - 80g",
].map((s) => (s || "").toString().trim().toLowerCase());

const defaultBestRegex = [
  /\bmedium\s+meat\s+sandwich\s*(?:-\s*)?80\s*g\b/i,
];

const defaultExcludeEn = [
  "Fries Sandwich 120g",
  "Meat Arabic Shawarma meal with fries 280g",
  "Meat Arabic Shawarma Combo Meal 280g with fries",
  "Meat Arabic Combo",
].map((s) => (s || "").toString().trim().toLowerCase());

const defaultExcludeRegex = [
  /\bfries\s+sandwich\s*120\s*g\b/i,
  /\bmeat\s+arabic\s+shawarma\s+combo\s+meal\b/i,
  /\bmeat\s+arabic\s+shawarma\s+meal\b/i,
];

const clampDiscount = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return 0;
  return Math.min(Math.max(Math.round(number), 0), 90);
};

export const getOfferOverrides = () => {
  if (typeof window === "undefined" || !window.localStorage) return {};

  try {
    const raw = window.localStorage.getItem(OFFERS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (_) {
    return {};
  }
};

export const saveOfferOverrides = (offers) => {
  if (typeof window === "undefined" || !window.localStorage) return;

  try {
    window.localStorage.setItem(OFFERS_STORAGE_KEY, JSON.stringify(offers || {}));
    window.dispatchEvent(new CustomEvent(OFFERS_UPDATED_EVENT));
  } catch (_) {}
};

export const emitOffersUpdated = () => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(new CustomEvent(OFFERS_UPDATED_EVENT));
};

export const getOfferForItem = (itemId, offers = getOfferOverrides()) => {
  return offers?.[itemId] || null;
};

export const isDefaultOfferItem = (item) => {
  const rawName = item?.name;
  const nameEn =
    typeof rawName === "object" ? rawName?.en || "" : item?.name || "";
  const nameAr =
    typeof rawName === "object" ? rawName?.ar || "" : item?.nameAr || "";
  const lowerEn = nameEn.toString().trim().toLowerCase();
  const isBestAr = defaultBestAr.some((keyword) =>
    nameAr.toString().includes(keyword)
  );
  const isBestEn =
    defaultBestEn.some((keyword) => lowerEn.includes(keyword)) ||
    defaultBestRegex.some((regex) => regex.test(nameEn));
  const isExcluded =
    defaultExcludeEn.some((keyword) => lowerEn.includes(keyword)) ||
    defaultExcludeRegex.some((regex) => regex.test(nameEn));

  return (isBestAr || isBestEn) && !isExcluded;
};

export const getEffectiveOffer = (item, offers = getOfferOverrides()) => {
  const offer = getOfferForItem(item.id, offers);

  if (offer) {
    const discountPercent = clampDiscount(offer.discountPercent);
    return {
      enabled: Boolean(offer.enabled) && discountPercent > 0,
      discountPercent,
      source: "admin",
    };
  }

  if (isDefaultOfferItem(item)) {
    return {
      enabled: true,
      discountPercent: DEFAULT_OFFER_PERCENT,
      source: "default",
    };
  }

  return {
    enabled: false,
    discountPercent: 0,
    source: "none",
  };
};

export const applyOfferOverrides = (items = [], offers = getOfferOverrides()) => {
  return items.map((item) => {
    const offer = getEffectiveOffer(item, offers);

    const { discountPrice, isBestSeller, ...baseItem } = item;

    if (!offer.enabled) {
      return baseItem;
    }

    const discountPercent = clampDiscount(offer.discountPercent);
    if (discountPercent <= 0) {
      return baseItem;
    }

    const price = Number(item.price || 0);
    const nextDiscountPrice =
      Math.round(price * (1 - discountPercent / 100) * 100) / 100;

    return {
      ...baseItem,
      discountPercent,
      discountPrice: nextDiscountPrice,
      isBestSeller: true,
    };
  });
};

export const normalizeDiscount = clampDiscount;
